import { gql } from '@apollo/client';

const LESSON_COMPLETION_STATS_FRAGMENT = gql`
  fragment BaseLessonCompletionStatsFragment on PrmLessonCompletionStats {
    metSkillPercentage
    unmetSkillPercentage
    metSkillWithSupportPercentage
    metSkillWithoutSupportPercentage
  }
`;

export default LESSON_COMPLETION_STATS_FRAGMENT;
